//Animated text
export const slideUp = {
    initial: {
        y: "100%"
    },
    open: (i: number) => ({
        y: "0%",
        transition: {duration: 0.5, delay: 0.01 * i}
    }),
    closed: {
        y: "100%",
        transition: {duration: 0.5}
    }
}

//Not used
export const opacity = {
    initial: {
        opacity: 0
    },
    open: {
        opacity: 1,
        transition: {duration: 0.5}
    },
    closed: {
        opacity: 0,
        transition: {duration: 0.5} 
    }
}

//Menu slide
export const transitionSlide = {
    initial: {x: "100% "},
    enter: {x: "0", transition: {duration: 0.7, ease: [0.76, 0, 0.24, 1]}},
    exit: {x: "100%", transition: {duration: 0.7, ease: [0.76, 0, 0.24, 1]}}
}

//Navigation items slide
export const slide = {

    initial: {x: 80},

    enter: (i: number) => ({x: 0, transition: {duration: 0.7, ease: [0.76, 0, 0.24, 1], delay: 0.05 * i}}),

    exit: (i: number) => ({x: 80, transition: {duration: 0.7, ease: [0.76, 0, 0.24, 1], delay: 0.05 * i}})

}